export const OFFER_REQUEST_SELECTED = `offerRequests/OFFER_REQUEST_SELECTED`
export const OFFER_REQUEST_CREATE = `offerRequests/OFFER_REQUEST_CREATE`
export const OFFER_REQUEST_CREATED = `offerRequests/OFFER_REQUEST_CREATED`
export const OFFER_REQUEST_UPDATED = `offerRequests/OFFER_REQUEST_UPDATED`
export const OFFER_REQUEST_STATUS_UPDATED = `offerRequests/OFFER_REQUEST_STATUS_UPDATED`
export const OFFER_REQUEST_REVIEWED = `offerRequests/OFFER_REQUEST_REVIEWED`
